import React from 'react'

const Termsandcond = () => {
    return (
        <div className='term_container'>
            <h1 className='terms_h_tag'>Terms and Conditions</h1>

            <h2 className='terms_h_tag'>1. Acceptance of Terms</h2>
            <p>By accessing and using [Your App/Website Name] ("we," "our," "us"), you agree to comply with these terms and conditions. If you do not agree, please do not use our services.</p>

            <h2 className='terms_h_tag'>2. User Eligibility</h2>
            <p>Users must be at least 13 years old to use our services. If under 13, parental consent is required.</p>

            <h2 className='terms_h_tag'>3. Account Registration</h2>
            <ul>
                <li>Users must provide accurate information during registration.</li>
                <li>You are responsible for maintaining the security of your account.</li>
                <li>We reserve the right to suspend or terminate accounts if false information is provided.</li>
            </ul>

            <h2 className='terms_h_tag'>4. Use of Services</h2>
            <ul>
                <li>Our platform is for educational purposes only.</li>
                <li>Users must not misuse the content, distribute copyrighted material, or engage in unlawful activities.</li>
                <li>Any breach of these terms may result in suspension or termination of access.</li>
            </ul>

            <h2 className='terms_h_tag'>5. Intellectual Property</h2>
            <p>All course materials, videos, and content are the property of [Your App/Website Name]. Users may not copy, reproduce, or distribute content without permission.</p>

            <h2 className='terms_h_tag'>6. Payments & Refunds</h2>
            <ul>
                <li>Certain courses or services may require payment.</li>
                <li>Refund policies will be specified on the payment page.</li>
            </ul>

            <h2 className='terms_h_tag'>7. Limitation of Liability</h2>
            <p>We are not responsible for any direct, indirect, or incidental damages resulting from the use of our services. We do not guarantee uninterrupted or error-free access.</p>

            <h2 className='terms_h_tag'>8. Updates to Policy</h2>
            <p>As the Company evolves, our privacy policy will need to evolve as well to cover new situations. You are advised to review this Policy regularly for any changes, as continued use is deemed approval of all changes.</p>

            <h2 className='terms_h_tag'>9. Modifications to Terms</h2>
            <p>As the Company evolves, our privacy policy will need to evolve as well to cover new situations. You are advised to review this Policy regularly for any changes, as continued use is deemed approval of all changes.</p>

            <h2 className='terms_h_tag'>10. Limitation of Liability (Extended)</h2>
            <p>The user acknowledges that the company is not the manufacturer of the content on the Website, Application, or YouTube Channel and shall not be liable for any repercussions for the content.</p>
            <p>In no event shall the Company, its officers, directors, employees, partners, or agents be liable to you or any third party for any special, incidental, indirect, consequential, or punitive damages whatsoever, including those resulting from loss of use, data, or profits, or any other claim arising out of or in connection with your use of, or access to, the Website, Application, or YouTube Channel.</p>
        </div>
    )
}

export default Termsandcond